import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Snackbar,
  Alert
} from "@mui/material";
import { Visibility, VisibilityOff, Lock } from "@mui/icons-material";
import apiClient from "../../BaseUrl/apiClient";
import { decrypt } from "../../components/cryptoUtil";



function ChangePassword() {
 const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
const token = localStorage.getItem("token");
  // const handleSubmit = () => {
  //   if (!oldPassword || !newPassword || !confirmPassword) {
  //     setSnackbar({ open: true, message: "All fields are required", severity: "error" });
  //     return;
  //   }
  //   if (newPassword.length < 8) {
  //     setSnackbar({ open: true, message: "New password must be at least 8 characters", severity: "error" });
  //     return;
  //   }
  //   if (newPassword !== confirmPassword) {
  //     setSnackbar({ open: true, message: "Passwords do not match", severity: "error" });
  //     return;
  //   }

  //   // TODO: Replace with your API call
  //   console.log("Password changed:", { oldPassword, newPassword });

  //   setSnackbar({ open: true, message: "Password changed successfully!", severity: "success" });
  //   setOldPassword("");
  //   setNewPassword("");
  //   setConfirmPassword("");
  // };




const handleSubmit = async () => {
  if (!oldPassword || !newPassword || !confirmPassword) {
    setSnackbar({ open: true, message: "All fields are required", severity: "error" });
    return;
  }
  if (newPassword.length < 8) {
    setSnackbar({ open: true, message: "New password must be at least 8 characters", severity: "error" });
    return;
  }
  if (newPassword !== confirmPassword) {
    setSnackbar({ open: true, message: "Passwords do not match", severity: "error" });
    return;
  }

  try {
     const UserDetails = (JSON.parse(decrypt(localStorage.getItem('tokenData'))));
    const res = await apiClient.post("/user/change-password", {
      userId : UserDetails.userId,
      oldPassword,
      newPassword
    },{headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },});

    setSnackbar({ open: true, message: res.data.message, severity: "success" });
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  } catch (err) {
    setSnackbar({
      open: true,
      message: err.response?.data?.message || "Error changing password",
      severity: "error"
    });
  }
};



  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
      sx={{
            backgroundColor: "#f5f7fa",
            height: 180,
            position: "relative",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
          }}
    >
      <Card sx={{ width: 400, boxShadow: 8, borderRadius: 4 }}>
        <CardContent>
          <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
            <Lock sx={{ fontSize: 30, color: "#2575fc", mr: 1 }} />
            <Typography  fontWeight="bold" sx={{ fontSize: 20, color: "#2575fc", mr: 1 }} >Change Password</Typography>
          </Box>

          <TextField
          
size="small"
            label="Old Password"
            type={showOld ? "text" : "password"}
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            fullWidth
            margin="normal"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowOld(!showOld)}>
                    {showOld ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <TextField
            label="New Password"
            size="small"
            type={showNew ? "text" : "password"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            fullWidth
            margin="normal"
            helperText="Must be at least 8 characters"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowNew(!showNew)}>
                    {showNew ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <TextField
            label="Confirm Password"
            size="small"
            type={showConfirm ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            fullWidth
            margin="normal"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowConfirm(!showConfirm)}>
                    {showConfirm ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2, py: 1.2, fontWeight: "bold", borderRadius: 3 }}
            onClick={handleSubmit}
          >
            Update Password
          </Button>
        </CardContent>
      </Card>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}


export default ChangePassword